<template>
  <LayoutContent>
    <SectionTitle :label="title" />
    <div v-if="loading" class="text-center" style="margin-top: 20%">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>
    <div v-else>
      <v-container v-if="orders.length" class="white rounded-lg" :class="{ 'pa-5': $vuetify.breakpoint.smAndUp, 'pa-0 pt-4': !$vuetify.breakpoint.smAndUp }">
        <div v-if="orders.length">
          <OrderListItem v-for="item in orders" :item="item" :key="item.po_number" @cancel="openCancelDialog" @addToCart="addOrderToCart" />
        </div>
      </v-container>
      <div v-else class="blank-message text-h6 font-weight-medium grey--text text-center">{{ $t('label.noOrdersListed') }}</div>
    </div>

    <!-- Cancel Order Dialog -->
    <app-dialog v-model="isCancelOrderDialog" :title="$t('label.cancelOrder')" max-width="700px" @click:outside="closeCancelDialog">
      <v-form @submit.prevent="submitCancelOrder" v-model="formIsValid" ref="cancelForm">
        <v-card-text class="d-flex flex-column align-center">
          <v-select
            v-model="cancelForm.reason"
            :rules="$rules.requiredRules"
            :items="cancellationReason"
            item-text="name"
            item-value="id"
            :label="$t('label.reasonOfCancellation')"
            rounded
            outlined
          ></v-select>
        </v-card-text>
        <v-card-actions class="d-flex flex-column align-stretch px-4">
          <app-button class="green-gradient-right override-disabled-styles mb-5" type="submit" :disabled="!formIsValid" invert gradient :label="$t('label.makeCancellation')" />
          <v-btn class="align-self-center primary--text" icon fab @click="closeCancelDialog"><LeftArrow /></v-btn>
        </v-card-actions>
      </v-form>
    </app-dialog>
  </LayoutContent>
</template>
<script>
import { mapActions } from 'vuex'
import { localeHelper } from '@/utils'
import { ROUTE_NAME } from '@/constants/route.constants'
import { PAYMENT } from '@/api/payment.api'
import { uiHelper } from '@/utils'

import LayoutContent from '@/views/layouts/LayoutContent.vue'
import SectionTitle from '@/components/SectionTitle.vue'
import OrderListItem from '@/components/order/OrderListItem.vue'
import LeftArrow from '@/assets/icons/left-arrow-circle.svg'

export default {
  components: { LayoutContent, SectionTitle, OrderListItem, LeftArrow },
  name: 'List',
  data: () => ({
    loading: false,
    orders: [],
    isCancelOrderDialog: false,
    cancelForm: {
      reason: ''
    },
    cancellationReason: [],
    formIsValid: false,
    selectedOrderItem: null,
    popup: null,
    abortController: new AbortController()
  }),
  async created() {
    await this.getCancellationReason().then(({ reason }) => {
      this.cancellationReason = reason
      this.cancelForm.reason = reason[0].id
    })
  },
  computed: {
    title() {
      let label = ''
      switch (parseInt(this.$route.params.id)) {
        case 1:
          label = localeHelper.getMessage('label.toPay')
          break
        case 2:
          label = localeHelper.getMessage('label.toShip')
          break
        case 3:
          label = localeHelper.getMessage('label.toReceive')
          break
        case 4:
          label = localeHelper.getMessage('label.delivered')
          break
        case 5:
          label = localeHelper.getMessage('label.completed')
          break
        case 6:
          label = localeHelper.getMessage('label.cancelled')
          break
        case 7:
          label = localeHelper.getMessage('label.returnRefund')
          break
      }
      return label
    }
  },
  created() {
    this.fetchList()
    this.fetchCancelReason()
  },
  methods: {
    ...mapActions('order', ['getOrderList', 'getCancellationReason', 'cancelOrder', 'buyAgain']),
    fetchList() {
      this.loading = true
      this.getOrderList(this.$route.params.id)
        .then((res) => {
          this.orders = res.order
        })
        .finally(() => (this.loading = false))
    },
    fetchCancelReason() {
      this.getCancellationReason().then((res) => {
        this.cancellationReason = res.reason
      })
    },
    openCancelDialog(item) {
      this.selectedOrderItem = item
      this.isCancelOrderDialog = true
    },
    closeCancelDialog() {
      this.isCancelOrderDialog = false
      this.$refs.cancelForm.reset()
      this.$refs.cancelForm.resetValidation()
    },
    async submitCancelOrder() {
      await this.cancelOrder({ order_id: this.selectedOrderItem.order_id, reason: this.cancelForm.reason })
        .then((res) => {
          this.fetchList()
          this.$toast.success(res.message)
        })
        .catch((err) => {
          this.$toast.error(err.message)
        })
        .finally(() => {
          this.closeCancelDialog()
        })
    },
    addOrderToCart(item) {
      this.selectedOrderItem = item
      this.buyAgain({ order_id: this.selectedOrderItem.order_id })
        .then((res) => {
          this.$toast.success(res.message)
          this.$router.push({ name: ROUTE_NAME.ORDER_CART })
        })
        .catch((err) => this.$toast.error(err.message))
    }
  }
}
</script>
<style lang="scss" scoped>
.blank-message {
  margin: 150px;
}
</style>
